
import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import SimpleDialog from "@/components/SimpleDialog.vue";

@Component({
    components: {
        SimpleDialog,
    },
})
export default class ApiQueryModal extends Vue {

    @Prop({default: null})
    public id: string;

    private selectedItem: any = null;
    private loading: boolean = false;
    private dialog: boolean = true;

    private async mounted(): Promise<void> {
      this.loading = true;
      await this.$store.dispatch("admin/apiQueries/getDetails", {
        id: this.id,
      }).then((res) => {
        this.selectedItem = res;
      }).catch((error) => {
        this.$store.commit("alerts/displayHttpError", { error });
      }).finally(() => {
        this.loading = false;
      });
    }

    private isSuccessStatus(status: string): boolean {
        return !!status && (status === "304" || status.slice(0, 1) === "2");
    }

    private getServiceColor(service: string): string {
        switch (service) {
            case "MYLOBY":
                return "orange";
            case "ACSES":
                return "blue";
            default:
                return null;
        }
    }
}
